import { render, staticRenderFns } from "./snsUpdate.vue?vue&type=template&id=549a5dc9&"
import script from "./snsUpdate.vue?vue&type=script&lang=js&"
export * from "./snsUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports